import request from "superagent";
import _ from "lodash";
// import moment from "moment-timezone";
import { Auth } from "aws-amplify";

import env from "../constants/env";
import * as userActions from "./user";
import state from "../state/state";
import { refreshCognitoSession, refreshCredentials } from "../utils/securityUtil";
// import { getOrgId } from "./orgsActions";
import { getLs, setLs } from "../utils/utils";
import { updateMemberInDb, updateMemberInfoInDb } from "./orgsActions";
import { showError, showSuccess, showWarning } from "./alertActions";
import { buildUserProfileCognitoPayload, getUserProfileAlgoliaSyncWarning, getUserProfileSaveErrorMessage, normalizeProfileEmail } from "../utils/userProfileUtils";

export function getIdentityId() {
	return state.select(["user", "identityId"]).get();
}

export function getUsername() {
	return state.select(["user", "username"]).get();
}

export function getTimezone() {
	return state.get(["user", "timeZone"]);

	// const org = state.get(["selectedOrg"]);
	// const tz = _.get(org, "member.timeZone", moment.tz.guess());
	// return tz ? tz : moment.tz.guess();
}

export function getInjectedSecurityContext() {
	return btoa(JSON.stringify(state.get(["user", "_injected_security_credentials"])));
}

export function getJwtToken(credentials = window.credentials) {
	return state.get(["user", "jwt"]);
}

export function isOrganizationAdministrator() {
	const org = state.get(["selectedOrg"]);
	return _.get(org, "member.administrator", false) === 1 ? true : false;
}

export function isOrganizationAuthor() {
	const org = state.get(["selectedOrg"]);
	return _.get(org, "member.author", false) === 1 ? true : false;
}

export function isOrganizationUser() {
	if (isOrganizationAdministrator() || isOrganizationAuthor()) {
		return false;
	} else {
		return true;
	}
}

// Hardwired right now to CC Internal group for JAB only
// Need this much more robust
export function isOrganizationEmployeeInternal() {
	const member = state.get(["selectedOrg", "member"]);
	const groups = member && Array.isArray(member.groups) ? member.groups : [];

	if (groups.includes("286a185b-24a8-11ee-941a-06bc2460c8ad")) {
		return true;
	}

	return false;
}

export function getDisplayName() {
	return state.get(["user", "displayName"]);

	// const org = state.get(["selectedOrg"]);
	// return _.get(org, "member.displayName", "?");
}

export function getEmail() {
	return state.get(["user", "email"]);
}

export function getEmailChatNotify() {
	return state.get(["user", "emailChatNotify"]);
}

export function getPhoneNumber() {
	return state.get(["user", "phone_number"]);
}

export function getPhoneNumChatNotify() {
	return state.get(["user", "phoneNumChatNotify"]);
}

export function getProfilePicture() {
	return state.get(["user", "profilePicture"]);
}

/**
 * Determine the current users role
 * @return<int> 0 - normal user, 1 - author, 2 -administrator
 */
export function getUserRole() {
	let role = 0;

	if (isOrganizationAdministrator()) {
		role = 2;
	} else if (isOrganizationAuthor()) {
		role = 1;
	}

	return role;
}

export function getGroupMemberships() {
	return state.get(["selectedOrg", "member", "groups"]);
}

export function isSelf(member) {
	return state.get(["selectedOrg", "member", "id"]) === member.id;
}

export const SUBSCRIPTION_PLAN_BASIC = "basic-plan";
export function getSubscriptionPlan() {
	return state.get(["user", "subscriptionPlan"]);
}

export async function updateAttribute(cognitoUser, name, value) {
	try {

		const params = {
			[name]: _.isString(value) ? value : JSON.stringify(value)
		};

		let user = await Auth.currentAuthenticatedUser();
		if (user) {
			await Auth.updateUserAttributes(user, params);
		}
	} catch (e) {
		console.warn("Failed to update user attribute", name, value, e);
		// alert("Failed to set user attribute " + e);
	}
}

function setMemberProp(prop, value) {
	state.set(["selectedOrg", "member", prop], value);

	const memberId = state.get(["selectedOrg", "member", "id"]);
	const members = state.get(["selectedOrg", "members"]);
	if (_.isArray(members)) {
		const memberIndex = _.findIndex(members, { id: memberId });
		if (memberIndex > -1) {
			state.set(["selectedOrg", "members", memberIndex, prop], value);
		}
	}

	const selectedOrgId = state.get(["selectedOrg", "id"]);
	const orgs = state.get(["orgs"]);
	if (_.isArray(orgs)) {
		const orgIndex = _.findIndex(orgs, { id: selectedOrgId });
		if (orgIndex > -1) {
			state.set(["orgs", orgIndex, "member", prop], value);
		}
	}
}

function setLoadedOrganizationMemberEmail(email) {
	setMemberProp("inviteEmail", email);

	const orgs = state.get(["orgs"]);
	if (!_.isArray(orgs)) {
		return;
	}

	orgs.forEach((org, orgIndex) => {
		const memberId = _.get(org, ["member", "id"]);
		if (memberId === undefined || memberId === null) {
			return;
		}

		state.set(["orgs", orgIndex, "member", "inviteEmail"], email);

		if (_.isArray(org.members)) {
			const memberIndex = _.findIndex(org.members, { id: memberId });
			if (memberIndex > -1) {
				state.set(["orgs", orgIndex, "members", memberIndex, "inviteEmail"], email);
			}
		}
	});
}

export function setDisplayName(displayName) {
	setMemberProp("displayName", displayName);
	state.set(["user", "displayName"], displayName);
}

export function setTimezone(timeZone) {
	setMemberProp("timeZone", timeZone);
	state.set(["user", "timeZone"], timeZone);
}

export async function saveChangesForMemberAdmin(member, memberInfo) {
	try {
		const response = await updateMemberInfoInDb(member.id, memberInfo);
		const algoliaSyncWarning = getUserProfileAlgoliaSyncWarning(response);
		if (algoliaSyncWarning) {
			showWarning("Member Info Saved with Warning", algoliaSyncWarning);
		} else {
			showSuccess("Member Info Saved", "The member profile information has been successfully saved.");
		}
		return response;
	} catch (err) {
		showError("Member Info Update Failed", getUserProfileSaveErrorMessage(err));
		throw err;
	}
}

export async function saveChanges(displayName, timeZone, email, emailChatNotify, profilePicture) {
	// Save all attributes that are editable
	const memberId = state.get(["selectedOrg", "member", "id"]);
	const normalizedEmail = normalizeProfileEmail(email);

	// profilePicture = profilePicture.replace("http://", "https://");

	try {
		if (memberId === undefined || memberId === null || memberId === "") {
			throw new Error("The current organization member could not be identified. Please reload and try again.");
		}

		await refreshCredentials();
		const res = await request.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.editCognitoUser(state.get(["user", "username"]))}`)
			.set("Authorization", userActions.getJwtToken())
			.set("Content-Type", "application/json")
			.send(JSON.stringify(buildUserProfileCognitoPayload({
				email: normalizedEmail,
				emailChatNotify,
				profilePicture
			})));

		// The organization service persists these values and propagates changed
		// indexed attributes (such as display name and profile picture) to Algolia.
		const memberUpdateResponse = await updateMemberInDb(memberId, displayName, timeZone, profilePicture);

		state.set(["user", "displayName"], displayName);
		setMemberProp("displayName", displayName);

		state.set(["user", "profilePicture"], profilePicture);
		setMemberProp("userProfileImage", profilePicture !== "" ? profilePicture : "none");

		state.set(["user", "timeZone"], timeZone);
		setMemberProp("timeZone", timeZone);

		state.set(["user", "email"], normalizedEmail);
		setLoadedOrganizationMemberEmail(normalizedEmail);

		state.set(["user", "emailChatNotify"], emailChatNotify);

		try {
			await refreshCognitoSession();
		} catch (refreshErr) {
			console.warn("Profile saved, but the Cognito session could not be refreshed.", refreshErr);
		}

		const algoliaSyncWarning = _.uniq([
			getUserProfileAlgoliaSyncWarning(res),
			getUserProfileAlgoliaSyncWarning(memberUpdateResponse)
		].filter(Boolean)).join(" ");
		if (algoliaSyncWarning) {
			showWarning("Profile Saved with Warning", algoliaSyncWarning);
		} else {
			showSuccess("Profile Saved", "Your user profile has been successfully saved.");
		}
		return res;
	} catch (err) {
		showError("Profile Update Failed", getUserProfileSaveErrorMessage(err));
		throw err;
	}
}

export function saveProfilePicture(profilePicture) {
	// Save all attributes that are editable
	// profilePicture = profilePicture.replace("http://", "https://");

	// Need to call api
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			request.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.editCognitoUser(state.get(["user", "username"]))}`)
				.set("Authorization", userActions.getJwtToken())
				.set("Content-Type", "application/json")
				.send(JSON.stringify({
					profilePicture: profilePicture
				}))
				.then(res => {
					state.set(["user", "profilePicture"], profilePicture);

					resolve(res);
				}).catch(err => {
					alert("There was an error saving your user profile.");
					reject(err);
				});
		});
	});
}

export function getLastOrg() {
	let result = getLs("_ambifi_last_org");
	if (result) {
		if (_.isString(result)) {
			try {
				result = JSON.parse(result);
			} catch (e) {
				console.warn("Failed to parse last org", e);
			}
		}
	}
	return result;
}

export function setLastOrg(org) {

	let value = org;
	if (!_.isString(org)) {
		value = JSON.stringify(value);
	}

	setLs("_ambifi_last_org", value);
}

const LAST_ACTIVITY_RECOVERY_PENDING_KEY = "_ambifi_last_activity_recovery_pending";
const LAST_ACTIVITY_RECOVERY_ARCHIVE_KEY = "_ambifi_last_activity_recovery_archive";
const MAX_ARCHIVED_ACTIVITY_RECOVERIES = 10;

function getRecoveryArchiveUsername() {
	return _.toString(getUsername() || "").trim();
}

function parseArchivedActivityRecoveries() {
	let result = getLs(LAST_ACTIVITY_RECOVERY_ARCHIVE_KEY);
	if (_.isString(result)) {
		try {
			result = JSON.parse(result);
		} catch (e) {
			console.warn("Failed to parse archived recovery drafts", e);
			return [];
		}
	}

	if (!_.isArray(result)) {
		return [];
	}

	return result
		.map((entry) => {
			if (!_.isObject(entry)) {
				return null;
			}

			const activity = _.isObject(entry.activity) ? entry.activity : null;
			const activityId = _.toString(entry.activityId || _.get(activity, "id", "")).trim();
			if (!activity || activityId === "" || !Object.prototype.hasOwnProperty.call(activity, "type")) {
				return null;
			}

			return {
				activityId,
				activityName: _.toString(entry.activityName || _.get(activity, "name", "")).trim(),
				archivedAt: _.isNumber(entry.archivedAt) ? entry.archivedAt : Date.now(),
				reason: _.toString(entry.reason || "unknown").trim() || "unknown",
				username: _.toString(entry.username || "").trim(),
				activity
			};
		})
		.filter(Boolean);
}

function persistArchivedActivityRecoveries(entries = []) {
	setLs(LAST_ACTIVITY_RECOVERY_ARCHIVE_KEY, JSON.stringify(entries));
}

export function setLastActivity(activity, forceSave = false) {
	if (forceSave || (_.isObject(activity) && activity.hasOwnProperty("type"))) {
		setLs("_ambifi_last_activity", JSON.stringify(activity));
	}
}

export function setLastActivityRecoveryPending(pending = true) {
	setLs(LAST_ACTIVITY_RECOVERY_PENDING_KEY, pending === true);
}

export function hasLastActivityRecoveryPending() {
	return getLs(LAST_ACTIVITY_RECOVERY_PENDING_KEY) === true;
}

export function preserveLastActivityForRecovery(activity) {
	setLastActivity(activity, true);
	setLastActivityRecoveryPending(true);
}

export function archiveActivityRecovery(activity, reason = "dismissed") {
	if (!_.isObject(activity) || !Object.prototype.hasOwnProperty.call(activity, "type")) {
		return false;
	}

	const activityId = _.toString(_.get(activity, "id", "")).trim();
	if (activityId === "") {
		return false;
	}

	const username = getRecoveryArchiveUsername();
	const entry = {
		activityId,
		activityName: _.toString(_.get(activity, "name", "")).trim(),
		archivedAt: Date.now(),
		reason: _.toString(reason || "dismissed").trim() || "dismissed",
		username,
		activity: _.cloneDeep(activity)
	};

	try {
		const archivedEntries = parseArchivedActivityRecoveries();
		const isSameUserEntry = (candidate) => {
			const candidateUsername = _.toString(_.get(candidate, "username", "")).trim();
			if (username !== "") {
				return candidateUsername === "" || candidateUsername === username;
			}
			return candidateUsername === "";
		};

		const otherEntries = archivedEntries.filter((candidate) => !isSameUserEntry(candidate));
		const sameUserEntries = archivedEntries.filter((candidate) => isSameUserEntry(candidate) && candidate.activityId !== activityId);
		const nextSameUserEntries = [entry, ...sameUserEntries]
			.sort((a, b) => (b.archivedAt || 0) - (a.archivedAt || 0))
			.slice(0, MAX_ARCHIVED_ACTIVITY_RECOVERIES);

		persistArchivedActivityRecoveries([...otherEntries, ...nextSameUserEntries]);
		return true;
	} catch (err) {
		console.warn("Unable to archive recovery draft", err);
		return false;
	}
}

export function archivePendingLastActivityRecovery(reason = "dismissed") {
	const lastActivity = getLastActivity();
	if (!_.isObject(lastActivity) || !Object.prototype.hasOwnProperty.call(lastActivity, "type")) {
		return false;
	}

	const archived = archiveActivityRecovery(lastActivity, reason);
	if (archived) {
		clearLastActivityRecovery();
	}
	return archived;
}

export function getArchivedActivityRecoveries() {
	const username = getRecoveryArchiveUsername();
	return parseArchivedActivityRecoveries()
		.filter((entry) => {
			if (username === "") {
				return true;
			}
			const entryUsername = _.toString(_.get(entry, "username", "")).trim();
			return entryUsername === "" || entryUsername === username;
		})
		.sort((a, b) => (b.archivedAt || 0) - (a.archivedAt || 0));
}

export function removeArchivedActivityRecovery(activityId) {
	const normalizedActivityId = _.toString(activityId || "").trim();
	if (normalizedActivityId === "") {
		return;
	}

	const username = getRecoveryArchiveUsername();
	const nextEntries = parseArchivedActivityRecoveries().filter((entry) => {
		const entryUsername = _.toString(_.get(entry, "username", "")).trim();
		const sameUser = username === "" ? entryUsername === "" : entryUsername === "" || entryUsername === username;
		return !(sameUser && entry.activityId === normalizedActivityId);
	});
	persistArchivedActivityRecoveries(nextEntries);
}

export function clearLastActivityRecovery() {
	setLastActivity({}, true);
	setLastActivityRecoveryPending(false);
}

export function getLastActivity() {
	let result = getLs("_ambifi_last_activity");
	if (_.isString(result)) {
		try {
			result = JSON.parse(result);
			return result;
		} catch (e) {
			console.warn("Failed to parse last org", e);
			return null;
		}
	}
}

export function getAllOrgs() {
	let result = [];

	const _allOrgs = getLs("_ambifi_all_orgs");
	if (_allOrgs) {
		if (_.isString(_allOrgs)) {
			try {
				result = JSON.parse(_allOrgs);
			} catch (e) {
				console.warn("Failed to parse orgs", e);
			}
		} else if (_.isArray(_allOrgs)) {
			result = _allOrgs;
		}

	}
	return result;
}
